export default __webpack_public_path__ + "static/media/cart-icon.6adc5994.png";